import Configs from './Config';

const qaConfigs: Configs = {
  dashboardUrl: 'https://dashboard.casaqa.ajira.tech',
  ruleServerUrl: 'https://api.casaqa.ajira.tech',
  casaWebAppUrl: 'https://web.casaqa.ajira.tech',
  casaEcomUrl: 'https://ecom.casaqa.ajira.tech',
  casaBeatUrl: 'https://beat-api.casaqa.ajira.tech',
  turnedOffFeatures: [],
  keycloakConfig: {
    url: `https://auth.casaqa.ajira.tech/auth`,
    realm: `casa`,
    clientId: `casa_dashboard`,
  },
};

export default qaConfigs;
